import React from 'react'
import { ah, sh, ReduxWrapper, compose, QueryWrapper } from 'common-data/datahelpers'
import { Grid, GridCell } from 'common-controls/Core/index'
import { FeedbackAdd } from 'common-views/Shared/ProfileAccount/Feedback/FeedbackAdd'
import { MessageBusWrapper } from 'common-tools/MessageBusHelper'
import { DrawerSizeOptions } from 'common-controls/Drawer/index'

export const LayoutHeader = compose(
  ReduxWrapper([
    sh.SessionUser,
    sh.SessionAccount
  ], [
    ah.clearAccount,
    ah.clearSettings,
    ah.sendToURL,
    ah.clearUser,
    ah.openDrawer
  ]),
  QueryWrapper({
    key: 'LayoutHeader',
    actions: [
      {
        url: '/Services/Profile/Logout',
        prop: 'Logout',
        map: false
      },
      {
        url: '/Services/Profile/Agency/Switch',
        prop: 'SwitchAgency',
        map: false
      }
    ]
  }),
  MessageBusWrapper
)(function LayoutHeaderPlain (props) {
  const { SessionAccount, SwitchAgency, Logout, clearSettings, clearUser, sendToURL, clearAccount, SessionUser, openDrawer, messageBusKey } = props

  function signOut () {
    Logout({ AccountKey: SessionAccount?._key }).then(() => {
      clearAccount()
      clearUser()
      clearSettings()
      sendToURL('/Login')
    })
  }

  function logOut () {
    SwitchAgency({ UserKey: 'Exit' }).then(() => {
      clearUser()
      sendToURL('/Me/Dashboard/Tasks')
    })
  }

  function getFeedback () {
    openDrawer(FeedbackAdd, messageBusKey, {}, DrawerSizeOptions.Middle)
  }
  return <>
    <Grid paddingX className='nav-hed'>
      <GridCell small={6} className="nav-hed-title">{SessionUser?.AgencyName}</GridCell>
      <GridCell small={6} className="text-right">
        {SessionUser?.IsAuthenticated
          ? <a onClick={() => { getFeedback() }} className="tiny logout-button">Feedback</a>
          : null
        }&nbsp;

        {SessionUser?.IsAuthenticated
          ? <a onClick={() => { logOut() }} className="tiny a-switch-button">Switch Agency</a>
          : null
        }&nbsp;
        <a className="tiny logout-button" onClick={() => { signOut() }}>Log Out</a>
      </GridCell>
    </Grid>
    <Grid paddingX>
      <GridCell small={12}>
        <hr />
      </GridCell>
    </Grid>
  </>
})
